import { env } from './env'

const getBoeHost = () =>
  Buffer.from('dm9sY2VuZ2luZWFwaS1ib2Utc3RhYmxlLmJ5dGVkLm9yZw==', 'base64').toString()

export const imagexConfig = env.isProd
  ? {
      region: 'cn-north-1',
      host: 'imagex.volcengineapi.com',
      accountId: '2100143557',
      serviceId: 'ivwd9ldvil',
      domain: 'https://p6-imagex-lite.volcimagex.com',
      appid: 351201,
    }
  : {
      region: 'boe',
      host: getBoeHost(),
      imageHost: `https://${getBoeHost()}`,
      accountId: '2000000912',
      serviceId: 'zici86j7y1',
      domain: 'https://p-imagex-lite.volcimagex.cn',
      appid: 10067709,
    }
